import React from "react";
import { Controller } from "react-hook-form";
import { cn } from "../../lib/cn";

const baseClasses = {
  select:
    "peer h-full w-full rounded-[7px] border bg-transparent px-3 py-2.5 font-sans text-sm font-normal outline outline-0 transition-all placeholder-shown:border focus:border-2 border-t-0 focus:border-t-0 focus:outline-0 disabled:border-0 disabled:bg-blue-slate-50",
  label:
    "before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none !overflow-visible truncate text-[11px] font-normal leading-tight transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:before:border-t-2 peer-focus:before:border-l-2 peer-focus:after:border-t-2 peer-focus:after:border-r-2 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-slate-500",
};

const variants = {
  default: {
    select:
      "border-slate-500 placeholder-shown:border-slate-500 placeholder-shown:border-t-slate-500 focus:border-slate-500",
    label:
      "text-slate-500 before:border-slate-500 after:border-slate-500 peer-placeholder-shown:text-slate-500 peer-focus:text-slate-500 peer-focus:before:border-slate-500 peer-focus:after:border-slate-500",
  },
  light: {
    select:
      "border-[#D1D5DB] placeholder-shown:border-[#D1D5DB] placeholder-shown:border-t-[#D1D5DB] focus:border-[#D1D5DB]",
    label:
      "text-[#6B7280] before:border-[#D1D5DB] after:border-[#D1D5DB] peer-placeholder-shown:text-[#6B7280] peer-focus:text-[#6B7280] peer-focus:before:border-[#D1D5DB] peer-focus:after:border-[#D1D5DB]",
  },
};

const errorClasses = {
  select:
    "border-red-500 placeholder-shown:border-red-500 placeholder-shown:border-t-red-500 focus:border-red-500",
  label:
    "text-red-500 before:border-red-500 after:border-red-500 peer-placeholder-shown:text-red-500 peer-focus:text-red-500 peer-focus:before:border-red-500 peer-focus:after:border-red-500",
};

const Select = ({
  name,
  control,
  rules,
  defaultValue,
  className = "w-full mt-8",
  label,
  variant = "default",
  options = [],
}) => {
  // Default option
  const defaultOption = { value: "", label: "Select An Option", disabled: true };
  const selectOptions = [defaultOption, ...options];

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue || ""}
      render={({ field, fieldState: { error } }) => (
        <div className={className}>
          <div className="relative w-full min-w-[150px] h-13">
            <select
              {...field}
              className={cn(
                baseClasses.select,
                error ? errorClasses.select : variants[variant].select
              )}
            >
              {selectOptions.map((option) => (
                <option
                  className="bg-slate-100 text-slate-800"
                  key={option.value}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option?.label ? option.label : option.value}
                </option>
              ))}
            </select>
            <label
              className={cn(
                baseClasses.label,
                error ? errorClasses.label : variants[variant].label
              )}
            >
              {label || "Select"}
            </label>
          </div>
          {error && (
            <p className="text-red-500 mt-1 text-xs">
              {error.message || "Error"}
            </p>
          )}
        </div>
      )}
    />
  );
};

export default Select;
